"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("babel-helper-vue-jsx-merge-props"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconBase = _interopRequireDefault(require("./IconBase"));

var _twoTonePrimaryColor = require("./twoTonePrimaryColor");

var _utils = require("../utils");

var _config = require("../config");

var _excluded = ["attrs"],
    _excluded2 = ["icon", "spin", "rotate", "tabIndex", "twoToneColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Initial setting
(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var Icon = {
  name: 'H3Icon',
  functional: true,
  props: {
    icon: Object,
    spin: Boolean,
    rotate: Number,
    tabIndex: [String, Number],
    twoToneColor: [String, Array]
  },
  render: function render(h, ctx) {
    var _ctx$data = ctx.data;
    _ctx$data = _ctx$data === void 0 ? {} : _ctx$data;
    var attrs = _ctx$data.attrs,
        restData = (0, _objectWithoutProperties2["default"])(_ctx$data, _excluded),
        _ctx$props = ctx.props,
        props = _ctx$props === void 0 ? {} : _ctx$props,
        listeners = ctx.listeners;

    var _attrs$props = _objectSpread(_objectSpread({}, attrs), props),
        icon = _attrs$props.icon,
        spin = _attrs$props.spin,
        rotate = _attrs$props.rotate,
        tabIndex = _attrs$props.tabIndex,
        twoToneColor = _attrs$props.twoToneColor,
        restProps = (0, _objectWithoutProperties2["default"])(_attrs$props, _excluded2);

    var onClick = listeners.click;
    var classString = (0, _classnames["default"])(_config.componentOptions.cssNamespace, (0, _defineProperty2["default"])({}, "".concat(_config.componentOptions.cssNamespace, "-").concat(icon.name), Boolean(icon.name)));
    var svgClassString = (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(_config.componentOptions.cssNamespace, "-spin"), !!spin));
    var iconTabIndex = tabIndex;

    if (iconTabIndex === undefined && onClick) {
      iconTabIndex = -1;
    }

    var svgStyle = rotate ? {
      msTransform: "rotate(".concat(rotate, "deg)"),
      transform: "rotate(".concat(rotate, "deg)")
    } : undefined;

    var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor),
        _normalizeTwoToneColo2 = (0, _slicedToArray2["default"])(_normalizeTwoToneColo, 2),
        primaryColor = _normalizeTwoToneColo2[0],
        secondaryColor = _normalizeTwoToneColo2[1];

    return h("span", (0, _babelHelperVueJsxMergeProps["default"])([{
      attrs: {
        role: "img",
        "aria-label": icon.name,
        tabIndex: iconTabIndex
      },
      "class": classString
    }, _objectSpread(_objectSpread({}, restData), {}, {
      attrs: restProps,
      on: listeners
    })]), [h(_IconBase["default"], {
      "class": svgClassString,
      attrs: {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
      },
      style: svgStyle
    })]);
  }
};
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports["default"] = _default;